export class Holiday{
  id?: number;
  name: string;
  holidaysConsistencyLookupId: number;
  holidaysConsistency?: string;
  severalDaysOff: boolean;
  startDate: any;
  endDate: any;
}
